const getProducts = (state) => state.products.listProducts;

export {getProducts};